function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var SORT_SUFFIXES = ["_price_asc", "_price_desc"];
var isProductionEnv = function isProductionEnv() {
  return process.env.VM_ENV === "production";
};
var currentMarket = function currentMarket() {
  return (process.env.VM_MARKET || "AU").toLowerCase();
};
export var getAlgoliaIndexes = function getAlgoliaIndexes() {
  var market = currentMarket();
  var prefix = isProductionEnv() ? market : "staging_".concat(market);
  return {
    OFFERS: "".concat(prefix, "_storefront_offers"),
    SITE_OFFERS: "".concat(prefix, "_storefront_site_offers")
  };
};

/**
 * Brand catalogue index, matching storefront `getOffersIndex`. Production AU
 * Whiskymofo uses `au_storefront_wm_site_offers`; Vinomofo uses `_vm_site`.
 */
export var getOffersIndex = function getOffersIndex() {
  var isWhiskymofo = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var isVinomofo = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var indexes = getAlgoliaIndexes();
  if (isProductionEnv() && (process.env.VM_MARKET || "AU") === "AU") {
    if (isWhiskymofo) {
      return indexes.SITE_OFFERS.replace("_site", "_wm_site");
    }
    if (isVinomofo) {
      return indexes.SITE_OFFERS.replace("_site", "_vm_site");
    }
  }
  return indexes.SITE_OFFERS;
};

/**
 * Index stamped onto Segment events. Algolia Insights reads
 * properties.search_index, so Whiskymofo must not inherit the shared
 * `*_storefront_offers` catalogue that localStorage often still holds.
 * Sort replicas (`_price_asc`, `_price_desc`) are kept when present.
 */
export var resolveTrackedAlgoliaIndex = function resolveTrackedAlgoliaIndex(stored, brandIndex, genericBases) {
  if (!stored) return brandIndex;
  if (stored === brandIndex || stored.startsWith("".concat(brandIndex, "_"))) return stored;
  var _iterator = _createForOfIteratorHelper(genericBases),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var base = _step.value;
      if (!base || base === brandIndex) continue;
      if (stored === base) return brandIndex;
      for (var _i = 0, _SORT_SUFFIXES = SORT_SUFFIXES; _i < _SORT_SUFFIXES.length; _i++) {
        var suffix = _SORT_SUFFIXES[_i];
        if (stored === "".concat(base).concat(suffix)) return "".concat(brandIndex).concat(suffix);
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return brandIndex;
};

/**
 * Checkout serves both brands from one app, so callers pass whether this
 * event belongs on the Whiskymofo catalogue (spirits-only / whisky events).
 * Non-WM events keep whatever localStorage still holds, matching storefront.
 */
export var getTrackedAlgoliaIndex = function getTrackedAlgoliaIndex() {
  var isWhiskymofo = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var stored = typeof localStorage !== "undefined" ? localStorage.getItem("algoliaIndexName") : null;
  if (!isWhiskymofo) return stored;
  var indexes = getAlgoliaIndexes();
  return resolveTrackedAlgoliaIndex(stored, getOffersIndex(true), [indexes.OFFERS, indexes.SITE_OFFERS]);
};
export var trackedAlgoliaIndexFields = function trackedAlgoliaIndexFields() {
  var isWhiskymofo = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var trackedIndex = getTrackedAlgoliaIndex(isWhiskymofo);
  var queryId = typeof localStorage !== "undefined" ? localStorage.getItem("queryID") : null;
  return {
    search_index: trackedIndex,
    index: trackedIndex,
    query_id: queryId,
    queryID: queryId
  };
};